const rows = [
  {
    name: "John",
    age: 30,
    gender: "Male",
    company: "NASA",
    location: "USA",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
  {
    name: "Sara",
    age: 35,
    gender: "Female",
    company: "SpaceX",
    location: "Russia",
    price: 10000,
  },
];

const columns = [
  {
    header: "Name",
    type: "string",
    accessorKey: "name",
  },
  {
    type: "number",
    header: "Age",
    accessorKey: "age",
  },
  {
    header: "Gender",
    type: "string",
    accessorKey: "gender",
  },
  {
    header: "Company",
    type: "string",
    accessorKey: "company",
  },
  {
    header: "Location",
    type: "string",
    accessorKey: "location", //simple recommended way to define a column
  },
  {
    header: "Price",
    type: "number",
    accessorKey: "price",
  },
];

const columnOrder = ["name", "age", "gender", "company", "location", "price"];

export const defaultData = { rows, columns, columnOrder };
